import React, { useRef } from "react";
import CreditReportAuthorizationPrompt from "./CreditReportAuthorizationPrompt";
import "./CreditReportAuthorization.css";

const CreditReportAuthorizationModal = ({
  modalId,
  triggerId,
  nextTriggerId,
  checked,
  onChange,
  disabled = false,
  inputId,
}) => {
  const transitionInProgressRef = useRef(false);

  const continueToConfirmation = () => {
    if (transitionInProgressRef.current) return;

    transitionInProgressRef.current = true;
    window.setTimeout(() => {
      document.getElementById(nextTriggerId)?.click();
      transitionInProgressRef.current = false;
    }, 180);
  };

  const skipAuthorization = () => {
    onChange(false);
    continueToConfirmation();
  };

  return (
    <>
      <button
        id={triggerId}
        type="button"
        data-bs-toggle="modal"
        data-bs-target={`#${modalId}`}
        className="d-none"
        aria-hidden="true"
        tabIndex="-1"
      />

      <div
        className="modal fade custom_modal credit-report-authorization-modal"
        id={modalId}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby={`${modalId}-title`}
        aria-hidden="true"
      >
        <div className="modal-dialog credit-report-authorization-dialog">
          <div className="modal-content">
            <button
              type="button"
              className="credit-report-modal__close"
              data-bs-dismiss="modal"
              aria-label="Close authorization"
            >
              &times;
            </button>

            <div className="modal-body credit-report-modal__body">
              <CreditReportAuthorizationPrompt
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                inputId={inputId}
                titleId={`${modalId}-title`}
              />

              <div className="credit-report-modal__actions">
                <button
                  type="button"
                  className="btn_brnd-outline"
                  data-bs-dismiss="modal"
                  onClick={skipAuthorization}
                >
                  Skip
                </button>
                <button
                  type="button"
                  className="btn_brnd"
                  data-bs-dismiss="modal"
                  onClick={continueToConfirmation}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditReportAuthorizationModal;
